import React, { FunctionComponent, useEffect, useState } from "react";
import cx from "classnames";
import * as styles from "./PageLayout.module.scss";
import Footer from "@components/Footer/Footer";
import DesktopHeader from "@components/Header/DesktopHeader/DesktopHeader";
import MobileHeader from "@components/Header/MobileHeader/MobileHeader";
import SEO from "./SEO";
import { PageLayoutMetaData, SeoPage } from "./_PageLayoutMetaData";
import { SEOProps } from "./SEO";
import OrganizationalSchema from "@components/Schemas/OrganizationalSchema";

export type SeoOptionsType =
	| { type: "PREDEFINED"; pageName: SeoPage }
	| { type: "BLOG"; data: SEOProps };

type PageLayoutProps = {
	seoOptions: SeoOptionsType;
	hideOverflowX?: boolean;
	defaultHeader?: "light" | "dark";
	children: React.ReactNode;
	fixedHeaderColor?: boolean;
	footerTheme?: "light" | "dark";
};

const PageLayout: FunctionComponent<PageLayoutProps> = ({
	seoOptions,
	children,
	defaultHeader,
	fixedHeaderColor,
	hideOverflowX = false,
	footerTheme = "light",
}) => {
	let pageNameProp = null as SeoPage | null;
	let seoData = null as SEOProps | null;
	if (seoOptions.type === "PREDEFINED") {
		pageNameProp = seoOptions.pageName;
		seoData = PageLayoutMetaData[pageNameProp];
	} else {
		seoData = seoOptions.data;
	}
	const [loadingEffect, setLoadingEffect] = useState(true);
	useEffect(() => {
		document.body.style.position = "unset";
		setTimeout(() => setLoadingEffect(false));
	}, []);
	return (
		<div
			className={cx(styles.pageLayout, {
				[styles.loadingEffect]: loadingEffect,
				[styles.overflowXHidden]: hideOverflowX,
			})}
		>
			<a className={cx("skip-link", styles.skipLink)} href="#main">
				Skip to main
			</a>
			<SEO {...seoData} />
			<OrganizationalSchema />
			<MobileHeader defaultHeader={defaultHeader} fixedColor={fixedHeaderColor}/>
			<DesktopHeader
				defaultHeader={defaultHeader}
				fixedColor={fixedHeaderColor}
			/>
			<div id="main" style={{ display: "none" }}></div>
			{children}
			<Footer theme={footerTheme} />
		</div>
	);
};

export default PageLayout;
